import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const Chip = ({ label, color,title }) => (
  <div className={clsx("rd--chip", `rd--chip--${color}`)}>
    {!["default"].includes(color) && <span className="rd--chip--bulletpoint" />}
    <span className="rd--chip--label" title={title || ''}>{label}</span>
  </div>
);

Chip.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.oneOf([
    "default",
    "green",
    "orange",
    "red",
    "gray",
    "liliac",
  ]).isRequired,
};

Chip.defaultProps = {
  color: "default",
};

export default Chip;
